import React, { useState } from "react";
import { fetchQuizQuestions } from "./api";
import QuizForm from "./components/QuizForm";
import QuizQuestions from "./components/QuizQuestions";
import QuizResult from "./components/QuizResult";
import './App.css';

const App = () => {
  const [questions, setQuestions] = useState([]);
  const [quizState, setQuizState] = useState("form");
  const [answers, setAnswers] = useState([]);
  const [error, setError] = useState(null);

  const startQuiz = async (topic, difficulty, questionCount) => {
    try {
      setError(null);
      const data = await fetchQuizQuestions(topic, difficulty, questionCount);
      setQuestions(data);
      setQuizState("quiz");
    } catch (err) {
      setError(err.message);
    }
  };

  const restart = () => {
    setQuestions([]);
    setAnswers([]);
    setError(null);
    setQuizState("form");
  };

  return (
    <div className="wrapper">
      <div className="logo-area">
        <img src="/quizfy.png" alt="Quizfy" className="logo" />
      </div>

      {error && <div className="error-box">{error}</div>}

      {quizState === "form" && <QuizForm onStartQuiz={startQuiz} />}
      {quizState === "quiz" && (
        <QuizQuestions questions={questions} onComplete={(a) => { setAnswers(a); setQuizState("result"); }} />
      )}
      {quizState === "result" && <QuizResult answers={answers} onRestart={restart} />}
    </div>
  );
};

export default App;
